module.exports = __webpack_public_path__ + "img/foot_phone.c1dc5ec5.png";